import React from 'react'
import { NoText } from './style'
import { EditWhiteIcon } from '../../utils/icons'
import { FlexWrapper, NewChampionsCard,EventCard, NewVideoPlayer, NewContentV2} from '../MainEvents/RecommendEventVideos/styles'
import Thumbnail from '../Thumbnail'
import {ImageUrl} from '../../utils/constants'
import { useState } from 'react'
import { useEffect } from 'react'
import { fetchApi } from '../../utils/methods'
import {GetAffirmationsDetailsAndPillars} from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify'
import { useHistory } from "react-router-dom";



function AffirmationsComponent() {
  const history = useHistory();

  const [formDetails, setFormDetails] = useState([]);
  const [onHover, setOnHover]=useState({});

  const onEnterMouse = (id) => {
    setOnHover(id)
  }
  
  const onLeaveMouse = () => {
    setOnHover(-1)
  };


  const FetchWellbeingPillarAndDetails = async()=>{
    const currentYear = new Date().getFullYear();
    try {
      const res = await fetchApi(`${GetAffirmationsDetailsAndPillars}/${currentYear}`, "GET");
      if(res.success === 'success'){
        setFormDetails(res?.data || []);
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  useEffect(() => {
    FetchWellbeingPillarAndDetails();
  }, []);


  return (
    <>
      {formDetails.length > 0  ? 
        
        <FlexWrapper>
          {formDetails
            .filter((item) => item.thumbnail_path && item.daily_affirmation_count > 0)?.map((item) => (
              <NewChampionsCard key={item.pillar_id}>
                <EventCard
                  onMouseEnter={() => onEnterMouse(item.pillar_id)}
                  onMouseLeave={() => onLeaveMouse()}>
                  <NewVideoPlayer>
                    <Thumbnail
                      style={{ cursor: 'default' }} 
                      src={`${ImageUrl}/${item?.thumbnail_path}`}
                      alt={'img'}
                    />
                  </NewVideoPlayer>
                  {onHover === item.pillar_id &&
                    <div className='educateImageBackground'  onClick={() =>
                      history.push({pathname:`/company/wellness/EditAffirmationForm`,
                        state: {
                          selectedPillarId: item.pillar_id,
                          selectedPillarData: item}})
                    }>
                      <div className="getStarted">
                        {EditWhiteIcon()}
                        {("Edit Affirmation")}
                      </div>
                    </div>
                  }
                  <NewContentV2 newPadding={'newPadding'} style={{ minHeight: 'auto',borderRadius:'0px 0px 12px 12px' }}>
                    <div className='firstContainer'>
                      <div className='name' title={item?.daily_affirmation_count}>
                        {item?.month}: {item?.wellbeing_pillar?.pillar_title}
                      </div>
                      <div className='tipText' >
                        {item?.daily_affirmation_count} affirmations added
                      </div>
                    </div>
                  </NewContentV2>
                </EventCard>
              </NewChampionsCard>
            ))}
        </FlexWrapper>:
        <NoText>
          No affirmations added yet!
        </NoText>}
    </>
  )
}

export default AffirmationsComponent
